export default {"src":"/_next/static/media/logo.ef78d483.svg","height":107,"width":348};